import React, { useState } from "react";
import constants from "../../../../constants";
import { getDataFromStorage } from "../../../../util";
import InputField from "../../../CommonComponents/InputField";
import InputDropdown from "../../../CommonComponents/InputDropdown";

const ArrowIcon = () => (
  <svg
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeWidth="2"
      stroke="#667085"
      d="M9 18L15 12L9 6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CheckIcon = ({ isActive }) => (
  <svg
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.6666 5L7.49998 14.1667L3.33331 10"
      stroke={isActive ? "#12B76A" : "#D0D5DD"}
    />
  </svg>
);

const EditIcon = ({ onClick, styles }) => (
  <button className="bdPathCheckBtn" style={styles} onClick={onClick}>
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeWidth="2"
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 16.6667H17.5M13.75 2.91669C14.0815 2.58517 14.5312 2.39893 15 2.39893C15.2321 2.39893 15.462 2.44465 15.6765 2.53349C15.891 2.62233 16.0858 2.75254 16.25 2.91669C16.4142 3.08085 16.5444 3.27572 16.6332 3.4902C16.722 3.70467 16.7678 3.93455 16.7678 4.16669C16.7678 4.39884 16.722 4.62871 16.6332 4.84319C16.5444 5.05766 16.4142 5.25254 16.25 5.41669L5.83333 15.8334L2.5 16.6667L3.33333 13.3334L13.75 2.91669Z"
      />
    </svg>
  </button>
);

const BatchPaths = ({
  paths,
  newPath,
  pathNames,
  setNewPath,
  addNewPath,
  batchDetails,
  isChangePathName,
  updateOldPathName,
  onChangeOldPathName,
  setIsChangePathName,
}) => {
  const isLMSorClientEval =
    (parseInt(getDataFromStorage("accountType")) ===
      constants.ACCOUNT_USAGE_TYPE.LMS &&
      (batchDetails.batchtype === constants.BATCH_TYPE.LEARNING || batchDetails.batchtype === constants.BATCH_TYPE.SELF ||
        ((batchDetails.batchtype === constants.BATCH_TYPE.TESTING ) &&
          !batchDetails?.learningpath?.length))) ||
    (parseInt(getDataFromStorage("accountType")) ===
      constants.ACCOUNT_USAGE_TYPE.CLIENT_EVAL &&
      !batchDetails?.learningpath?.length);

  const [editPathIndex, setEditPathIndex] = useState(null);

  const handleEditPathDetails = (event, index) => {
    event.preventDefault();
    setIsChangePathName(true);
    setEditPathIndex(index);
  };

  const onSelectNewPath = (value) => {
    let pathOptions = structuredClone(paths);
    let path = pathOptions.find((path) => path.value === value);
    setNewPath((prev) => ({
      ...prev,
      lpId: path.value,
      lpName: path.label,
      courseName: path.label,
    }));
  };

  return (
    <div className="bdPathSec">
      {batchDetails?.learningpath?.map((lp, index) =>
        lp.lpid && lp.lpname ? (
          <div className="bdPath" key={index}>
            <InputDropdown
              disabled
              type="default"
              options={paths}
              value={lp.lpid}
              placeholder="Select Path"
              label={index === 0 ? "Path" : null}
            />
            <div className={index === 0 ? "bdPathArrowIcon" : ""}>
              <ArrowIcon />
            </div>
            <div className="bdRenameSec">
              <InputField
                type="default"
                placeholder="Rename path name"
                disabled={editPathIndex !== index}
                value={pathNames[lp.lpid]?.coursename}
                onChange={(event) =>
                  onChangeOldPathName(event.target.value, lp.lpid)
                }
                label={
                  index === 0 ? (
                    <div className="bdPathNameLabel">
                      Rename Path for Batch<span> (Optional)</span>
                    </div>
                  ) : null
                }
              />
              {editPathIndex !== index && (
                <EditIcon
                  styles={{ marginTop: index === 0 ? "26px" : "0" }}
                  onClick={(event) => handleEditPathDetails(event, index)}
                />
              )}
              {isChangePathName && editPathIndex === index && (
                <button
                  className="bdPathCheckBtn"
                  style={{ marginTop: index === 0 ? "26px" : 0 }}
                  onClick={(event) => {
                    setEditPathIndex(null);
                    updateOldPathName(event, lp.lpid);
                  }}
                >
                  <CheckIcon isActive />
                </button>
              )}
            </div>
          </div>
        ) : null
      )}
      {isLMSorClientEval && (
        <div className="bdPath">
          <InputDropdown
            type="default"
            options={paths}
            value={newPath.lpId}
            placeholder="Select Path"
            label={
              batchDetails?.learningpath.length > 0 &&
              batchDetails?.learningpath[0]?.lpid
                ? null
                : "Path"
            }
            searchable
            onChange={(value) => onSelectNewPath(value)}
          />
          <div
            className={
              batchDetails?.learningpath.length === 0 ? "bdPathArrowIcon" : ""
            }
          >
            <ArrowIcon />
          </div>
          <div className="bdRenameSec">
            <InputField
              type="default"
              value={newPath.courseName}
              placeholder="Rename path name"
              onChange={(event) =>
                setNewPath((prev) => ({
                  ...prev,
                  courseName: event.target.value,
                }))
              }
              label={
                batchDetails?.learningpath.length > 0 &&
                batchDetails?.learningpath[0]?.lpid ? null : (
                  <div className="bdPathNameLabel">
                    Rename Path for Batch<span> (Optional)</span>
                  </div>
                )
              }
            />
            <button
              onClick={addNewPath}
              disabled={!newPath.lpId}
              className={`bdPathCheckBtn ${newPath.lpId ? "allowed" : ""}`}
              style={{
                marginTop: !batchDetails?.learningpath.length ? "26px" : "",
              }}
            >
              <CheckIcon />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BatchPaths;
